var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "create_dialog",
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.isOpen,
            "show-close": true,
            fullscreen: true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpen = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticClass: "title_dialog" }, [
                    _c("span", [_vm._v("Tạo phiếu khảo sát")]),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "body_dialog" }, [
            _c("div", { staticClass: "survey_form" }, [
              _c(
                "section",
                { staticClass: "wrap_image_form radius border" },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "uploadImageSurveyForm",
                      staticClass: "upload_image_form",
                      class: { hideUpload: _vm.listImageForm.length > 0 },
                      attrs: {
                        action: "#",
                        "list-type": "picture-card",
                        "auto-upload": false,
                        "file-list": "listImageForm",
                        limit: 1,
                        accept: "image/*",
                        "show-file-list": true,
                        "on-change": _vm.handleUploadImage,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "file",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "container_image" }, [
                                _c("img", {
                                  staticClass: "el-upload-list__item-thumbnail",
                                  attrs: { src: scope.file.url, alt: "Ảnh" },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "el-upload-list__item-actions",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-preview",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handlePictureCardPreview(
                                              scope.file
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-zoom-in",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-delete",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRemoveImage(
                                              scope.file
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                ],
                1
              ),
              _c(
                "section",
                {
                  staticClass: "header_survey_form radius border element_form",
                },
                [
                  _c("el-input", {
                    staticClass: "header_survey_title",
                    attrs: {
                      type: "text",
                      placeholder: "Tiêu đề phiếu khảo sát",
                      maxlength: 100,
                      "show-word-limit": true,
                    },
                    on: {
                      blur: function ($event) {
                        return _vm.handleChangeInputHeader()
                      },
                    },
                    model: {
                      value: _vm.defaultDataForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.defaultDataForm, "title", $$v)
                      },
                      expression: "defaultDataForm.title",
                    },
                  }),
                  _c("el-input", {
                    staticClass: "header_survey_description",
                    attrs: {
                      type: "textarea",
                      placeholder: "Mô tả phiếu khảo sát",
                      maxlength: 500,
                      "show-word-limit": true,
                      autosize: { minRows: 3, maxRows: 6 },
                      rows: 3,
                    },
                    model: {
                      value: _vm.defaultDataForm.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.defaultDataForm, "description", $$v)
                      },
                      expression: "defaultDataForm.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "section",
                { ref: "wrapQuestion", staticClass: "wrap_question" },
                [
                  _vm._l(
                    _vm.defaultDataForm.questionList,
                    function (question, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          ref: `elementForm-${index}`,
                          refInFor: true,
                          staticClass: "radius border element_form",
                          on: {
                            click: function ($event) {
                              return _vm.handleElementClick(index)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "element_body" },
                            [
                              _c(
                                "el-row",
                                { attrs: { type: "flex", gutter: 14 } },
                                [
                                  _c("el-col", { attrs: { span: 14 } }, [
                                    _c(
                                      "div",
                                      { staticClass: "element_question" },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            type: "text",
                                            placeholder: "Câu hỏi",
                                            maxlength: 100,
                                            "show-word-limit": true,
                                          },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.handleChangeTitleQuestion(
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value: question.questionText,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                question,
                                                "questionText",
                                                $$v
                                              )
                                            },
                                            expression: "question.questionText",
                                          },
                                        }),
                                        question.type === "Text"
                                          ? _c("el-input", {
                                              attrs: {
                                                type: "textarea",
                                                placeholder: "Văn bản trả lời",
                                                maxlength: 500,
                                                "show-word-limit": true,
                                                rows: 3,
                                                disabled: true,
                                                autosize: {
                                                  minRows: 3,
                                                  maxRows: 6,
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        question.type === "CheckBox"
                                          ? _c(
                                              "div",
                                              { staticClass: "wrap_checkbox" },
                                              [
                                                _vm._l(
                                                  question.valueQuestionArray,
                                                  function (item, indexOption) {
                                                    return _c(
                                                      "el-checkbox",
                                                      {
                                                        key: indexOption,
                                                        staticClass:
                                                          "container_checkbox",
                                                        attrs: {
                                                          disabled: true,
                                                          label: item.value,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              display:
                                                                "inline-block",
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              staticClass:
                                                                "checkbox_options",
                                                              staticStyle: {
                                                                width: "100%",
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                placeholder:
                                                                  "Tuỳ chọn",
                                                                maxlength: 100,
                                                                "show-word-limit": true,
                                                              },
                                                              on: {
                                                                blur: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.handleChangeValueQuestion(
                                                                    index,
                                                                    indexOption
                                                                  )
                                                                },
                                                              },
                                                              model: {
                                                                value:
                                                                  item.value,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      item,
                                                                      "value",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "item.value",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        question
                                                          .valueQuestionArray
                                                          .length > 1
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  display:
                                                                    "inline-block",
                                                                  "margin-left":
                                                                    "30px",
                                                                  "font-size":
                                                                    "16px",
                                                                  color: "#000",
                                                                  cursor:
                                                                    "pointer",
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-close",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleRemoveOptions(
                                                                          question.valueQuestionArray,
                                                                          indexOption
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "add_option",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleFocusAddOptions(
                                                            question.valueQuestionArray,
                                                            `inputAddOptions-${index}`
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-circle-plus",
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-weight":
                                                              "900",
                                                          },
                                                        },
                                                        [_vm._v("Thêm")]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                        question.type === "Radio"
                                          ? _c(
                                              "div",
                                              { staticClass: "wrap_checkbox" },
                                              [
                                                _vm._l(
                                                  question.valueQuestionArray,
                                                  function (item, indexOption) {
                                                    return _c(
                                                      "el-radio",
                                                      {
                                                        key: indexOption,
                                                        staticClass:
                                                          "container_checkbox",
                                                        attrs: {
                                                          disabled: true,
                                                          label: item.value,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              display:
                                                                "inline-block",
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              staticClass:
                                                                "checkbox_options",
                                                              staticStyle: {
                                                                width: "100%",
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                placeholder:
                                                                  "Tuỳ chọn",
                                                                maxlength: 100,
                                                                "show-word-limit": true,
                                                              },
                                                              on: {
                                                                blur: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.handleChangeValueQuestion(
                                                                    index,
                                                                    indexOption
                                                                  )
                                                                },
                                                              },
                                                              model: {
                                                                value:
                                                                  item.value,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      item,
                                                                      "value",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "item.value",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        question
                                                          .valueQuestionArray
                                                          .length > 1
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  display:
                                                                    "inline-block",
                                                                  "margin-left":
                                                                    "30px",
                                                                  "font-size":
                                                                    "16px",
                                                                  color: "#000",
                                                                  cursor:
                                                                    "pointer",
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-close",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleRemoveOptions(
                                                                          question.valueQuestionArray,
                                                                          indexOption
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "add_option",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleFocusAddOptions(
                                                            question.valueQuestionArray,
                                                            `inputAddOptions-${index}`
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-circle-plus",
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-weight":
                                                              "900",
                                                          },
                                                        },
                                                        [_vm._v("Thêm")]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                        question.type === "Point"
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-row",
                                                  { attrs: { type: "flex" } },
                                                  _vm._l(
                                                    10,
                                                    function (item, index) {
                                                      return _c(
                                                        "el-col",
                                                        {
                                                          key: index,
                                                          attrs: { span: 2 },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                                "justify-content":
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "option_point",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        item
                                                                      ) +
                                                                      "\n                          "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        question.type === "Star"
                                          ? _c("div", [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    gap: "0 10px",
                                                  },
                                                },
                                                _vm._l(5, function (item) {
                                                  return _c(
                                                    "span",
                                                    {
                                                      key: item,
                                                      staticClass: "icon_star",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-star-off",
                                                      }),
                                                    ]
                                                  )
                                                }),
                                                0
                                              ),
                                            ])
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c("el-col", { attrs: { span: 10 } }, [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "end",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "220px" },
                                            on: {
                                              change: (value) =>
                                                _vm.handleChangeTypeQuestion(
                                                  question,
                                                  value
                                                ),
                                              focus: function ($event) {
                                                return _vm.handleElementClick(
                                                  index
                                                )
                                              },
                                            },
                                            model: {
                                              value: question.type,
                                              callback: function ($$v) {
                                                _vm.$set(question, "type", $$v)
                                              },
                                              expression: "question.type",
                                            },
                                          },
                                          _vm._l(
                                            _vm.typeQuestionOptions,
                                            function (item, index) {
                                              return _c(
                                                "el-option",
                                                {
                                                  key: index,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        gap: "0 20px",
                                                        height: "100%",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            padding: "5px",
                                                          },
                                                        },
                                                        [
                                                          _c("el-image", {
                                                            attrs: {
                                                              src: item.icon,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-weight":
                                                              "600",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.label)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "element_footer" }, [
                            _c(
                              "span",
                              {
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleCloneQuestion(index)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-copy-document",
                                }),
                              ]
                            ),
                            _vm.defaultDataForm.questionList.length > 1
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: { cursor: "pointer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleRemoveQuestion(index)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-delete" })]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "wrap_require" },
                              [
                                _c("span", { staticClass: "label_require" }, [
                                  _vm._v("Bắt buộc"),
                                ]),
                                _c("el-switch", {
                                  model: {
                                    value: question.obligatory,
                                    callback: function ($$v) {
                                      _vm.$set(question, "obligatory", $$v)
                                    },
                                    expression: "question.obligatory",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    }
                  ),
                  _vm.defaultDataForm.questionList.length > 0
                    ? _c(
                        "div",
                        { ref: "scrollTasks", staticClass: "scroll_tasks" },
                        [
                          _c("el-tooltip", { attrs: { placement: "right" } }, [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [_vm._v("Thêm câu hỏi")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "btn_scroll_tasks",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAddNewQuestion(
                                      _vm.currentQuestionIndex
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-circle-plus-outline",
                                }),
                              ]
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
              _c("section", [
                _c(
                  "div",
                  { staticClass: "wrap_button_tasks" },
                  [
                    _c(
                      "el-tooltip",
                      { attrs: { placement: "top" } },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [_vm._v("Thêm câu hỏi")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { circle: "" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAddNewQuestion(
                                  _vm.defaultDataForm.questionList.length - 1
                                )
                              },
                            },
                          },
                          [_c("i", { staticClass: "el-icon-plus" })]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              staticStyle: { display: "flex", "justify-content": "center" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                { staticClass: "dialog-footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-circle-close", type: "danger" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("\n          Hủy bỏ\n        ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        icon: "el-icon-circle-check",
                        loading: _vm.isLoading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleSaveForm()
                        },
                      },
                    },
                    [_vm._v("\n          Lưu\n        ")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog_image",
          attrs: {
            top: "40px",
            width: "30%",
            visible: _vm.isDialog.dialogVisibleImage,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.isDialog, "dialogVisibleImage", $event)
            },
          },
        },
        [
          _c("img", {
            attrs: {
              width: "100%",
              src: _vm.isDialog.dialogImageUrl,
              alt: "Ảnh phiếu",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }